import React from 'react';
import { Link } from 'react-router-dom';

const UpgradeRequired = () => {
  return (
    <div className="feature-unavailable">
      <h2>Feature Unavailable</h2>
      <div>
        This feature is not available in the GoFormz subscription you currently have.
        <br />
        <br />
        Would you like to learn more about upgrading? <Link to="/subscription">Learn More</Link>
      </div>
    </div>
  );
};

export default UpgradeRequired;
